// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const enquireData = createApi({
  reducerPath: "enquireApi",
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_API_URL }),
  endpoints: (builder) => ({
    getClassAttempt: builder.query({
      query: (class_id) => ({
        url: `get_class_attempt`,
        params: {
          class_id,
        },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    addEnquiry: builder.mutation({
      query: (body) => ({
        url: `add_enquire`,
        method: "POST",
        body,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    addCourseEnquiry: builder.mutation({
      query: (body) => ({
        url: `add_course_enquire`,
        method: "POST",
        body,
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetClassAttemptQuery,
  useAddEnquiryMutation,
  useAddCourseEnquiryMutation,
} = enquireData;
